import { mapState } from 'vuex';
import { fetchProjectList } from '../../../contactLogic/manage/index';
import Web3 from "web3";
export default {
    name: 'artList',
    data() {
        return {
            projectList: [],
            loading: false,
        };
    },
    components: {
        issueCardModal: () =>
            import ('./dialog/IssueCardDialog.vue'),
    },
    computed: {
        ...mapState(['web3', 'ethersprovider', 'ethChainID', 'ethAddress']),
        isReady() {
            return this.web3 && this.ethersprovider && this.ethChainID && this.ethAddress;
        },
        productsCols() {
            return [{
                    title: 'ID',
                    slot: "project_id",
                },
                {
                    title: 'Name',
                    slot: "projectName",
                    minWidth: 20
                },
                {
                    title: 'Artist',
                    slot: "artist",
                    minWidth: 40
                },
                {
                    title: 'Description',
                    slot: "description",
                    minWidth: 50
                },
                {
                    title: 'License',
                    slot: "license",
                    minWidth: 20
                },
                {
                    title: 'Website',
                    slot: "website",
                    minWidth: 50
                },
                {
                    title: 'Dynamic',
                    slot: "dynamic",
                    minWidth: 30
                },
                {
                    title: 'Price',
                    slot: "price",
                    minWidth: 30
                },
                {
                    title: 'Passport ProjectId',
                    slot: "PassportMint",
                    minWidth: 30
                },
                {
                    title: 'Minted',
                    slot: "mint",
                    minWidth: 60
                },
                {
                    title: 'Edit',
                    slot: "edit",
                    minWidth: 40
                },
                {
                    title: 'Script/Image',
                    slot: "script",
                    minWidth: 50
                },
                {
                    title: 'Settings',
                    slot: "setting",
                    minWidth: 40
                },
                {
                    title: 'Issue card',
                    slot: "issue",
                    minWidth: 60
                },
                // {
                //     title: 'Paused',
                //     slot: "paused",
                //     minWidth: 30
                // },
                // {
                //     title: 'Locked',
                //     slot: "locked",
                //     minWidth: 40
                // },
                // {
                //     title: 'BaseApi',
                //     slot: "baseApi",
                //     minWidth: 40,
                // }
            ];
        }
    },
    methods: {
        toSettings(id) {
            this.$router.push(`/manage/settings/${id}`);
        },
        getTokenPrice(price) {
            if (!price) {
                return false;
            }
            const res = Web3.utils.fromWei(price);
            return `${res} ETH`;
        },
        getParams() {
            return {
                web3: this.web3,
                library: this.ethersprovider,
                account: this.ethAddress,
                chainID: this.ethChainID,
            };
        },
        async getProjectList() {
            try {
                this.loading = true;
                const params = this.getParams();
                const isAll = this.$route.fullPath.includes('allProjects');
                this.projectList = await fetchProjectList({
                    ...params,
                    all: isAll,
                });
                console.log('project', this.projectList);
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        onEditClick(row) {
            this.$router.push(`/manage/edit/${row.project_id}/${row.token_info.ArtistAddress}`);
        },
        onEditScriptClick(row) {
            this.$router.push(`/manage/preview/${row.project_id}/${row.token_info.ArtistAddress}`);
        },
        onEditImageClick(row) {
            this.$router.push(`/uploadImage/${row.project_id}`);
        },
        onNameClick(row) {
            this.$router.push(`/projectDetail/${row.project_id}`);
        },
        openIssueCardDialog(data) {
            this.$refs.issueCard.open(data);
        },
    },
    watch: {
        isReady(val) {
            if (val) {
                this.getProjectList();
            }
        },
        ['$route.path'](newVal, oldVal) {
            if (newVal !== oldVal) {
              this.getProjectList();
            }
        }
    },
    created() {
        if (this.isReady) {
            this.getProjectList();
        }
    }
};
